module.exports = __webpack_public_path__ + "img/product4.21d48536.png";